import { ComponentUtils } from '@Components/utils'

import './selector.scss'

export type Selectable<T> = {
  label: string
  value: T
}

export type SelectorProps<T> = {
  className?: string
  ariaLabel: string
  placeHolderText: string
  selectables: Selectable<T>[]
  value?: string
  onValueChange: (val: T) => void
  required?: boolean
  disabled?: boolean
}

const CLASS_NAME = 'selector'

export const Selector = <T,>({
  ariaLabel,
  className,
  placeHolderText,
  selectables,
  value,
  onValueChange,
  required,
  disabled,
}: SelectorProps<T>) => {
  const classNames: string[] = [CLASS_NAME]
  if (className) {
    classNames.push(className)
  }

  const valueChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onValueChange(event.target.value as T)
  }

  return (
    <select
      className={ComponentUtils.mapClassPrefixesWithSuffix(classNames, '-input')}
      aria-label={ariaLabel}
      onChange={valueChangeHandler}
      value={value ?? placeHolderText}
      required={required}
      disabled={disabled}>
      <option value={placeHolderText} disabled hidden>
        {placeHolderText}
      </option>

      {selectables.map((s) => {
        return (
          <option key={`option-${s.label}`} value={`${s.value}`}>
            {s.label}
          </option>
        )
      })}
    </select>
  )
}
